/**
 * carousel
 */

import $ from 'jquery';
import 'slick-carousel';

// Module dependencies
import 'protons';

// Module styles
import './_carousel.scss';

// Module template
import './_carousel.twig';

export const name = 'carousel';

export const defaults = {
  dummyClass: 'js-carousel-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

function initCarousel($carouselWrapper) {
  const $carousel = $carouselWrapper.find('.fm-carousel');
  const globalSettings = {
    pauseOnHover: true,
    draggable: false,
    slidesToScroll: 1,
    dots: true,
    mobileFirst: true,
    accessibility: true,
    cssEase: 'ease',
    respondTo: 'window',
    touchMove: true,
    autoplay: $carousel.data('autoplay'),
    autoplaySpeed: $carousel.data('speed'),
    appendDots: $carouselWrapper.find('.carousel-indicators'),
    prevArrow: $carouselWrapper.find('.carousel-controls--prev'),
    nextArrow: $carouselWrapper.find('.carousel-controls--next'),
    fade: $carousel.data('fade'),
  };
  const responsiveSettings = {
    responsive: [
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  };

  if ($carousel.data('slidesToShow') >= 3) {
    $carousel.slick({
      ...globalSettings,
      ...responsiveSettings,
    });
  } else {
    $carousel.slick({
      ...globalSettings,
      slidesToShow: $carousel.data('slidesToShow'),
    });
  }
}

export function enable($context) {
  const $carousels = $('.carousel__wrapper', $context);
  // Bail if component does not exist
  if (!$carousels.length) {
    return;
  }

  // Initiate carousel
  $carousels.each((i, el) => {
    initCarousel($(el));
  });
}

function enhanceAllSlickDotsAccessibility() {
  $(document).on('init reInit afterChange', '.slick-slider', function (event, slick, currentSlide) {
    const $dots = $(slick.$dots);
    if (!$dots.length) return;

    $dots.attr('role', 'tablist');

    $dots.find('li').each(function (index) {
      const $li = $(this);
      const $btn = $li.find('button');
      const isActive = $li.hasClass('slick-active');

      $li
        .attr('role', 'tab')
        .attr('tabindex', '0')
        .attr('aria-selected', isActive ? 'true' : 'false')
        .attr('aria-label', `Slide ${index + 1} of ${slick.$slides.length}`);

      // Clean and add keyboard listeners
      $li.off('keydown').on('keydown', function (e) {
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          const next = (index + 1) % slick.$dots.find('li').length;
          slick.$dots.find('li').eq(next).focus();
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          const prev = (index - 1 + slick.$dots.find('li').length) % slick.$dots.find('li').length;
          slick.$dots.find('li').eq(prev).focus();
        } else if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          $btn.trigger('click'); // trigger click on hidden button
        }
      });
    });
  });

  // If carousels are already initialized
  $('.slick-slider.slick-initialized').each(function () {
    $(this).trigger('afterChange', [$(this).slick('getSlick'), $(this).slick('slickCurrentSlide')]);
  });
}

function enableKeyboardForArrowIcons() {
  $(document).on('keydown', 'i[role="button"]', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      $(this).trigger('click');
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  enhanceAllSlickDotsAccessibility();
  enableKeyboardForArrowIcons();
});

export default enable;
